import React, { Component } from 'react';
import { tracker } from '@carvana/analytics';
import { Error } from '../../pages/404';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const track = tracker(this.props.AnalyticConfig);
    track('trackEvent', 'issue rendering ui', { clickstream: { error, errorInfo } }, [
      'clickstream'
    ]);

    console.error('There was an error trying to render', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) return <Error />;

    return this.props.children;
  }
}
